import { createRestApiClient } from '..';
import { productCategoryUrls } from '../../Constants/StaticPages';

export const productCategoryData = (pageName) => {
  const restApiClient = createRestApiClient();
  const params = { pageName: pageName, fromCache: false };
  //dev-api.myloapp.in/new/webCatPage/getPageByName?pageName=pagename&fromCache=true
  return restApiClient
    .request({
      method: 'GET',
      url: '/new/webCatPage/getPageByName',
      params: params,
    })
    .then((res) => res.data);
};

export const getProductCategorySitemapData = () => {
  const restApiClient = createRestApiClient();
  //https:dev-api.myloapp.in/new/webCatPage/getSiteMapData
  return restApiClient
    .request({
      method: 'GET',
      url: '/new/webCatPage/getSiteMapData',
    })
    .then((res) => {
      const data = res.data;
      data['data'] = [...data['data']];
      return data;
    });
};
